import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=3440e76e&scoped=true&"
import script from "./submit.vue?vue&type=script&lang=ts&"
export * from "./submit.vue?vue&type=script&lang=ts&"
import style0 from "./submit.vue?vue&type=style&index=0&id=3440e76e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3440e76e",
  null
  
)

export default component.exports